/*
 * FamilyFreightSimulateForm Messages
 *
 * This contains all the text for the FamilyFreightSimulateForm container.
 */

import { defineMessages } from 'react-intl';

export const scope = 'app.containers.families.FamilyFreightSimulateForm';

export default defineMessages({
  postCodeRequired: {
    id: `${scope}.postCodeRequired`,
    defaultMessage: 'Por favor, informe o seu CEP',
  },
  inputLabel: {
    id: `${scope}.inputLabel`,
    defaultMessage: 'Calcular frete e prazo de entrega ',
  },
  postCodeInputPlaceholder: {
    id: `${scope}.postCodeInputPlaceholder`,
    defaultMessage: 'Qual o seu CEP?',
  },
  estimatedDeliveryDateLabel: {
    id: `${scope}.estimatedDeliveryDateLabel`,
    defaultMessage: 'estimado para {deliveryDate}',
  },
  buttonLabel: {
    id: `${scope}.shippingCalculateButtonLabel`,
    defaultMessage: 'Calcular',
  },
  noOptionsMessage: {
    id: `${scope}.noOptionsMessage`,
    defaultMessage: 'Nenhuma opção disponível para o CEP {postCode}',
  },
});
